@if (selectCardService.selection.hasValue() && modalState === 2) {
  <div
    class="col col-12 p-0"
    >
    <div class="row ark-selection-counter-container">
      <div class="col-auto ark-selection-counter-content">
        <mat-checkbox
          [checked]="true"
          color="primary"
          (change)="selectCardService.selectCard($event, null, key)"
        ></mat-checkbox>
        <span class="ark-selectionCounter-label">{{
          'general.Deselect' | translate
        }}</span>
        <span class="ark-selectionCounter-number">{{
          selectCardService.selection.selected.length
        }}</span>
      </div>
      <div
        class="col-auto d-flex align-items-center ark-container-sected-actions flex-wrap"
        >
        <!--Load options-->
        @if (tasks.length <= 2) {
          <!--#region Loop of the tasks-->
          @for (task of forceShowButtons ? tasks.slice(0, 2) : tasks; track task.Key) {
            <!--#region If the tasks have options, show submenu-->
            @if (task.Options) {
              <a
                mat-raised-button
                class="btn ark-btn my-0"
                [matMenuTriggerFor]="options"
                color="primary"
                >
                <span
                  >{{ task.Name | translate }} <i class="fas fa-caret-down"></i
                ></span>
              </a>
              <mat-menu #options="matMenu" class="ark-overlay-container">
                @for (option of task.Options; track option.Key) {
                  <button
                    mat-menu-item
                    (click)="onSelectedOptions(option.Key)"
                    >
                    {{ option.Name | translate }}
                  </button>
                }
              </mat-menu>
            }
            <!--#endregion -->
            @if (!task.Options) {
              @if (!task.SelectorOptions) {
                <a
                  mat-raised-button
                  class="btn ark-btn my-0"
                  color="primary"
                  (click)="onSelectedOptions(task.Key)"
        [disabled]="
          task.Key === 'delete' &&
          items === selectCardService.selection.selected.length
        "
                  >
                  <span>{{ task.Name | translate }}</span>
                </a>
              }
              <!--#region Only for show generic selector-->
              @if (task.SelectorOptions) {
                <a
                  mat-raised-button
                  appSelectorButton
                  color="primary"
                  [selector]="selectorOptions"
                  class="btn ark-btn my-0"
                  (click)="onSelectedOptions(task.Key)"
                  >
                  <span>{{ task.Name | translate }}</span>
                </a>
                <app-selector
                  #selectorOptions
                  [options]="task.SelectorOptions"
                  (selectedChange)="onOptionSelected($event)"
                  >
                </app-selector>
              }
              <!--#endregion -->
            }
          }
          <!--#endregion -->
        } @else {
          <!--#region When show buttons is forced-->
          @if (forceShowButtons) {
            <!--#region Loop of the tasks-->
            @for (task of forceShowButtons ? tasks.slice(0, 2) : tasks; track task.Key) {
              <!--#region If the tasks have options, show submenu-->
              @if (task.Options) {
                <a
                  mat-raised-button
                  class="btn ark-btn my-0"
                  [matMenuTriggerFor]="options"
                  color="primary"
                  >
                  <span
                    >{{ task.Name | translate }} <i class="fas fa-caret-down"></i
                  ></span>
                </a>
                <mat-menu #options="matMenu" class="ark-overlay-container">
                  @for (option of task.Options; track option.Key) {
                    <button
                      mat-menu-item
                      (click)="onSelectedOptions(option.Key)"
                      >
                      {{ option.Name | translate }}
                    </button>
                  }
                </mat-menu>
              }
              <!--#endregion -->
              @if (!task.Options) {
                @if (!task.SelectorOptions) {
                  <a
                    mat-raised-button
                    class="btn ark-btn my-0"
                    color="primary"
                    (click)="onSelectedOptions(task.Key)"
        [disabled]="
          task.Key === 'delete' &&
          items === selectCardService.selection.selected.length
        "
                    >
                    <span>{{ task.Name | translate }}</span>
                  </a>
                }
                <!--#region Only for show generic selector-->
                @if (task.SelectorOptions) {
                  <a
                    mat-raised-button
                    appSelectorButton
                    color="primary"
                    [selector]="selectorOptions"
                    class="btn ark-btn my-0"
                    (click)="onSelectedOptions(task.Key)"
                    >
                    <span>{{ task.Name | translate }}</span>
                  </a>
                  <app-selector
                    #selectorOptions
                    [options]="task.SelectorOptions"
                    (selectedChange)="onOptionSelected($event)"
                    >
                  </app-selector>
                }
                <!--#endregion -->
              }
            }
            <!--#endregion -->
          }
          <!--  #endregion-->
          @if (!massiveAct) {
            <a
              mat-raised-button
              class="btn ark-btn my-0"
              [matMenuTriggerFor]="optionsSelectElements"
              color="primary"
              >
              <span
                >{{
                (forceShowButtons ? titleForceShowButtons : 'general.Actions')
                | translate
                }}
                <i class="fas fa-caret-down"></i
                ></span>
              </a>
            }
            @if (massiveAct) {
              <a
                mat-raised-button
                class="btn ark-btn my-0"
                [matMenuTriggerFor]="optionsSelectElements"
                color="primary"
                >
                <span
                  >{{
                  (forceShowButtons ? titleForceShowButtons : 'general.MassiveActions')
                  | translate
                  }}
                  <i class="fas fa-caret-down"></i
                  ></span>
                </a>
              }
              <mat-menu #optionsSelectElements="matMenu" class="ark-overlay-container">
                <!--#region Loop of the tasks-->
                @for (
                  task of forceShowButtons ? tasks.slice(2, tasks.length) : tasks
                  ; track task.Key) {
                  <!--#region If the tasks have options, show submenu-->
                  @if (task.Options) {
                    <button mat-menu-item [matMenuTriggerFor]="options">
                      <span>{{ task.Name | translate }}</span>
                    </button>
                    <mat-menu #options="matMenu" class="ark-overlay-container">
                      @for (option of task.Options; track option.Key) {
                        @if (!task.SelectorOptions) {
                          <button
                            mat-menu-item
                            (click)="onSelectedOptions(task.Key)"
                            >
                            {{ option.Name | translate }}
                          </button>
                        }
                        <!--#region Only for show generic selector-->
                        @if (task.SelectorOptions) {
                          <button
                            appSelectorButton
                            [selector]="selectorOptions"
                            mat-menu-item
                            (click)="onSelectedOptions(task.Key)"
                            >
                            {{ option.Name | translate }}
                          </button>
                          <app-selector
                            #selectorOptions
                            [options]="task.SelectorOptions"
                            (selectedChange)="onOptionSelected($event)"
                            >
                          </app-selector>
                        }
                        <!--#endregion -->
                      }
                    </mat-menu>
                  }
                  <!--#endregion If the tasks have options, show submenu-->
                  @if (!task.Options) {
                    @if (!task.SelectorOptions) {
                      <button
                        mat-menu-item
                        (click)="onSelectedOptions(task.Key)"
                        class="tk-button"
                        >
                        <span>{{ task.Name | translate }}</span>
                        @if (task?.ShowCount) {
                          <span class="tk-selection-counter">{{
                            selectCardService.selection.selected.length
                          }}</span>
                        }
                      </button>
                    }
                    <!--#region Only for show generic selector-->
                    @if (task.SelectorOptions) {
                      <button
                        appSelectorButton
                        [selector]="selectorOptions"
                        mat-menu-item
                        (click)="onSelectedOptions(task.Key)"
                        >
                        <span>{{ task.Name | translate }}</span>
                      </button>
                      <app-selector
                        #selectorOptions
                        [options]="task.SelectorOptions"
                        (selectedChange)="onOptionSelected($event)"
                        >
                      </app-selector>
                    }
                    <!--#endregion -->
                  }
                }
                <!--#endregion Loop of the tasks-->
              </mat-menu>
            }
          </div>
          @if (items === selectCardService.selection.selected.length) {
            <div
              class="row ark-selection-counter-container mt-2"
              >
              <div class="alert alert-primary itemActive" role="alert">
                <p>
                  <i class="fas fa-info-circle mr-2"></i
                    >{{ 'channels.HasAtLeastOneActive' | translate }}
                  </p>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!--#region When the tasks have more than two options -->
      <!--#endregion -->

      <!--#region when it have two options or less-->
      <!--#endregion-->
